
      import InProcess from './in-process.vue'
      import type { App, Plugin } from 'vue'

      export const InProcessPlugin: Plugin = {
        install(app: App) {
          app.component('InProcess', InProcess)
        },
      }
      export { InProcess }
      